import { useQuery } from '@tanstack/react-query';
import { getTeams, type GetTeamsParams } from '@/api/teams';
import type { TeamsListResponse } from '@/types/teams';

export function useTeams(params: GetTeamsParams & { enabled?: boolean } = {}) {
  const { season_id, limit = 50, offset = 0, search, enabled = true } = params;
  return useQuery<TeamsListResponse>({
    queryKey: ['teams', { season_id, limit, offset, search }],
    queryFn: () => getTeams({ season_id, limit, offset, search }),
    enabled,
    staleTime: 5 * 60 * 1000, // 5 minutes - teams don't change often
  });
}

